// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","384":"jspdf","582":"autotable"}[chunkId] || chunkId) + "." + {"102":"f46f0aaf","239":"886b511b","384":"2ab357f1","455":"2cab4567","488":"8351f746","582":"8c6c71d9","977":"eab1c1b9"}[chunkId] + ".chunk.js";
};